import makeHTTPRequest from '../../makeHTTPRequest';

export const show = () => makeHTTPRequest({ path: '/dialer/settings' });
